import { events } from "./events";

// src/utils/analytics.js
const ENDPOINT = process.env.REACT_APP_FASTAPI_BACKEND_URL + '/analytics/events';
// import CrudService from "services/cruds-service";

/* ------------------------------------------------------------------ */
/*  1. helpers                                                        */
/* ------------------------------------------------------------------ */
function randomId() {
  // 128-bit hex without external libs
  const buf = new Uint32Array(4);
  crypto.getRandomValues(buf);
  return [...buf].map(x => x.toString(16).padStart(8, '0')).join('');
}

function deviceInfo() {
  // Use User-Agent Client Hints if available
  if (navigator.userAgentData) {
    const { brands, platform, mobile } = navigator.userAgentData;
    return {
      browser: brands.map(b => b.brand).join(' '),
      os: platform,
      deviceType: mobile ? 'mobile' : 'desktop'
    };
  }
  // Light regex fallback
  const ua = navigator.userAgent;
  const browser =
    /edg/i.test(ua) ? 'Edge'
      : /chrome|crios/i.test(ua) ? 'Chrome'
        : /firefox|fxios/i.test(ua) ? 'Firefox'
          : /safari/i.test(ua) ? 'Safari'
            : 'Other';
  const os =
    /windows/i.test(ua) ? 'Windows'
      : /mac/i.test(ua) ? 'macOS'
        : /android/i.test(ua) ? 'Android'
          : /linux/i.test(ua) ? 'Linux'
            : 'Other';
  return { browser, os, deviceType: /mobile/i.test(ua) ? 'mobile' : 'desktop' };
}

/* ------------------------------------------------------------------ */
/*  2. core exporter                                                  */
/* ------------------------------------------------------------------ */
class Analytics {
  constructor() {
    this.sessionId = randomId();
    this.queue = [];
    this.flush = this.flush.bind(this);

    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') this.flush();
    });


    window.addEventListener('beforeunload', () => {
      const end_time = Date.now();
      this.track(events.APP_LEFT, {
        end_time: end_time,
      });
      this.flush();
    });
  }

  track(event, extras = {}) {
    this.queue.push({
      event,
      ...extras,
      timestamp: Date.now(),
      sessionId: this.sessionId,
      device: deviceInfo(),
      locale: navigator.language
    });
    if (this.queue.length > 20) this.flush(); // simple back-pressure
  }

  flush() {
    if (!this.queue.length) return;
    const payload = this.queue.splice(0, this.queue.length);
    // payload["userId"] = await CrudService.getUser();
    // Try sendBeacon first
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    const ok = navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, blob);
    if (ok) return;

    // Fallback to asynchronous fetch
    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true   // Node 14 accepts this with express.json
    }).catch(() => { });
  }
}

export const analytics = new Analytics();
